import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { OutgoingEvents, OutgoingEventsModel, OutgoingEventsTableConfig } from './model/outgoing-events-hybrid';
import { ModalSize, SystemApiService } from '@cv-invision/core';
import { GenericCrudService, GenericFormService } from '@cv-invision/cv.invision-views.ux';
import { OutgoingEventsHybridService } from './service/outgoing-events-hybrid.service';

@Component({
	selector: 'cv-outgoing-events-hybrid',
	templateUrl: './outgoing-events-hybrid.component.html',
	styleUrls: ['./outgoing-events-hybrid.component.scss']
})
export class OutgoingEventsHybridComponent implements OnInit, OnDestroy {
	private atComponentDestroy = new Subject<void>();

	public config: OutgoingEventsTableConfig;
	public extraData: any = {};
	public integrationParams: any;
	public eventsData: any[] = [];
	public tableModel = OutgoingEventsModel;
	public formBuilderConfig = OutgoingEvents.formBuilderConfig;
	public readonly ModalSize = ModalSize;
	public currentRow;
	public activeTabForm = ['product', 'productHybrid', 'productNonHybrid']

	constructor(
		private systemApiService: SystemApiService,
		private genericCrudService: GenericCrudService,
		private outgoingEventsHybridService: OutgoingEventsHybridService,
		private genericFormService: GenericFormService
	) {
		this.extraData = {
			editInModal: true,
			saveAsObject: true,
		};

		this.config = new OutgoingEventsTableConfig();
		this.currentRow = null;
	}

	ngOnInit(): void {
		this.config.baseUrl = `${this.systemApiService.api.orders}/utils/integrations/list-all-non-generic`;
		this.config.urlGetRecordData = `${this.systemApiService.api.orders}/utils/integrations`;

		this.genericCrudService
			.onRowClick$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: any) => {
				this.currentRow = event.row;
			});

		this.genericFormService
			.formObserver
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				if (data) {
					this.outgoingEventsHybridService.getIntegrationOutgoingEvents(this.currentRow.name).pipe(takeUntil(this.atComponentDestroy)).subscribe(response => {

						const eventNameOptions = Object.entries(response.cmpRelation).map(([key, label]) => ({
							value: key,
							label: label
						}));

						const postIf = response.postValues.map(item => ({
							value: item,
							label: item
						}));

						this.genericFormService.formFieldList['product']['childFormBuilderConfig']['eventName']['options'] = eventNameOptions;
						this.genericFormService.formFieldList['product']['childFormBuilderConfig']['postIf']['options'] = postIf;

						this.genericFormService.formFieldList['productHybrid']['childFormBuilderConfig']['eventName']['options'] = eventNameOptions;
						this.genericFormService.formFieldList['productHybrid']['childFormBuilderConfig']['postIf']['options'] = postIf;

						this.genericFormService.formFieldList['productNonHybrid']['childFormBuilderConfig']['eventName']['options'] = eventNameOptions;
						this.genericFormService.formFieldList['productNonHybrid']['childFormBuilderConfig']['postIf']['options'] = postIf;

						this.activeTabForm.forEach(element => {
							this.genericFormService.formFieldList[element]['child'].forEach(element => {
								element['eventName']['options'] = eventNameOptions;
								element['postIf']['options'] = postIf;
							});
						})
					});
				}
			})
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.complete();
	}
}